import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import LoginModal from '../components/LoginModal';  
import API_URL from "../config";
import {
  FaSearch,
  FaMapMarkerAlt,
  FaBriefcase,
  FaBuilding,
  FaGraduationCap,
  FaBookmark,
  FaChevronDown,
  FaChevronUp,
  FaUsers,
  FaClock,
  FaUser,
  FaFilter,
  FaTimes
} from "react-icons/fa";

import healthcareHero from "../assets/find-jobs-hero.png";
import hireCuraIcon from "../assets/hirecura-icon.png";

function FindJobs() {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginRole, setLoginRole] = useState("candidate");

const openLoginModal = (role) => {
  setLoginRole(role);
  setShowLoginModal(true);
};

  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });


  const [jobs, setJobs] = useState([]);

  const [roleSearch, setRoleSearch] = useState("");
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [professionFilter, setProfessionFilter] = useState("");
const [jobTypeFilter, setJobTypeFilter] = useState([]);

const [selectedOrganizations, setSelectedOrganizations] = useState([]);
const [selectedLocations, setSelectedLocations] = useState([]);

  const [showMoreProfession, setShowMoreProfession] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [draftProfessionFilter, setDraftProfessionFilter] = useState("");
  const [draftJobTypeFilter, setDraftJobTypeFilter] = useState([]);
  const [draftSelectedOrganizations, setDraftSelectedOrganizations] = useState([]);
  const [draftSelectedLocations, setDraftSelectedLocations] = useState([]);
  const [sortBy, setSortBy] = useState("Latest");
  // Pagination
const JOBS_PER_PAGE = 12;
const [currentPage, setCurrentPage] = useState(1);

  const [bookmarkedJobs, setBookmarkedJobs] = useState([]);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/jobs/all`
      );

      if (Array.isArray(res.data)) {
        setJobs(res.data);
      } else {
        setJobs([]);
      }
    } catch (error) {
      console.log(error);
      setJobs([]);
    }
  };

  const getTimeAgo = (date) => {
    if (!date) return "";

    const now = new Date();
    const posted = new Date(date);

    const seconds = Math.floor((now - posted) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes} mins ago`;
    if (hours < 24) return `${hours} hrs ago`;
    if (days === 1) return "1 day ago";

    return `${days} days ago`;
  };

  const isJobActive = (job) => {
    if (
      job.status &&
      job.status.toLowerCase() !== "active"
    ) {
      return false;
    }

    if (
      job.expires_at &&
      new Date(job.expires_at) < new Date()
    ) {
      return false;
    }

    return true;
  };
  const activeJobs = jobs.filter(isJobActive);

const getOrganizationName = (job) =>
  (
    job.organization_name ||
    job.company_name ||
    job.institution_name ||
    ""
  ).trim();

const organizationOptions = [
  ...new Set(
    activeJobs.map(getOrganizationName).filter(Boolean)
  ),
].sort((a, b) => a.localeCompare(b));

const locationOptions = [
  ...new Set(
    activeJobs
      .map((job) => (job.location || "").trim())
      .filter(Boolean)
  ),
].sort((a, b) => a.localeCompare(b));

  const filteredJobs = jobs
    .filter(isJobActive)
    .filter((job) => {
      const roleText = roleSearch.toLowerCase().trim();
      const organizationText =
        organizationSearch.toLowerCase().trim();
      const locationText =
        locationSearch.toLowerCase().trim();
      const professionText =
        professionFilter.toLowerCase().trim();

      const matchesRole =
        !roleText ||
        (job.role || "")
          .toLowerCase()
          .includes(roleText) ||
        (job.skills_required || "")
          .toLowerCase()
          .includes(roleText);

    const organization =
  job.organization_name ||
  job.company_name ||
  job.institution_name ||
  "";

const matchesOrganizationSearch =
  !organizationText ||
  organization.toLowerCase().includes(organizationText);
const matchesLocationSearch =
  !locationText ||
  (job.location || "").toLowerCase().includes(locationText);

const matchesOrganizationFilter =
  selectedOrganizations.length === 0 ||
  selectedOrganizations.includes(getOrganizationName(job));

const matchesLocationFilter =
  selectedLocations.length === 0 ||
  selectedLocations.includes((job.location || "").trim());

      const matchesProfession =
        !professionText ||
        (job.profession || "")
          .toLowerCase()
          .includes(professionText);

      

const normalizeJobType = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const jobType = normalizeJobType(
  job.job_type || job.employment_type
);

const matchesJobType =
  jobTypeFilter.length === 0 ||
  jobTypeFilter.some((type) => {
    const selectedType = normalizeJobType(type);

    const aliases = {
      "full time": ["full time", "fulltime"],
      "part time": ["part time", "parttime"],
      contract: ["contract", "contractual"],
    };

    const acceptedValues = aliases[selectedType] || [
      selectedType,
    ];

    return acceptedValues.includes(jobType);
  });



return (
  matchesRole &&
  matchesOrganizationSearch &&
  matchesLocationSearch &&
  matchesProfession &&
  matchesJobType &&
  matchesOrganizationFilter &&
  matchesLocationFilter
);
    });

  const sortedJobs = [...filteredJobs].sort((a, b) => {
    if (sortBy === "Latest") {
      return (
        new Date(b.created_at || 0) -
        new Date(a.created_at || 0)
      );
    }

    if (sortBy === "Oldest") {
      return (
        new Date(a.created_at || 0) -
        new Date(b.created_at || 0)
      );
    }

    return 0;
  });
// Reset to page 1 whenever search, filters, or sorting change
useEffect(() => {
  setCurrentPage(1);
}, [
  roleSearch,
  organizationSearch,
  locationSearch,
  professionFilter,
  jobTypeFilter,
  selectedOrganizations,
  selectedLocations,
  sortBy,
]);
// Pagination calculations
const totalPages = Math.ceil(
  sortedJobs.length / JOBS_PER_PAGE
);

const startIndex = (currentPage - 1) * JOBS_PER_PAGE;

const paginatedJobs = sortedJobs.slice(
  startIndex,
  startIndex + JOBS_PER_PAGE
);

// Keep the current page valid if the job count changes
useEffect(() => {
  if (totalPages > 0 && currentPage > totalPages) {
    setCurrentPage(totalPages);
  }
}, [currentPage, totalPages]);

const clearAllFilters = () => {
  setRoleSearch("");
  setOrganizationSearch("");
  setLocationSearch("");
  setProfessionFilter("");
  setJobTypeFilter([]);
  setSelectedOrganizations([]);
  setSelectedLocations([]);
  setCurrentPage(1);
};

  const handlePopularSearch = (value) => {
    setRoleSearch(value);
  };

 const toggleBookmark = async (jobId) => {
  // Redirect to Candidate Login if not logged in
  if (!loggedUser) {
    openLoginModal("candidate");
    return;
  }

  // Only candidates can save jobs
  if (loggedUser.role !== "candidate") {
    openLoginModal("candidate");
    return;
  }

  try {
    const response = await axios.get(
      `${API_URL}/saved-jobs/${loggedUser.id}`
    );

    const savedJobs = response.data || [];
    const existingSavedJob = savedJobs.find(
      (savedJob) => Number(savedJob.job_id) === Number(jobId)
    );

    if (existingSavedJob) {
      await axios.delete(
        `${API_URL}/saved-jobs/${existingSavedJob.id}`
      );
    } else {
      await axios.post(
        `${API_URL}/saved-jobs/save`,
        {
          candidate_id: loggedUser.id,
          job_id: jobId,
        }
      );
    }

    // Refresh saved status on the job cards
    const updatedResponse = await axios.get(
      `${API_URL}/saved-jobs/${loggedUser.id}`
    );

    setBookmarkedJobs(
      (updatedResponse.data || []).map((savedJob) =>
        Number(savedJob.job_id)
      )
    );
  } catch (error) {
    console.error("Error updating saved job:", error);
    alert("Unable to update saved job. Please try again.");
  }
};
useEffect(() => {
  if (!loggedUser || loggedUser.role !== "candidate") {
    setBookmarkedJobs([]);
    return;
  }

  const fetchSavedJobs = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/saved-jobs/${loggedUser.id}`
      );

      setBookmarkedJobs(
        (response.data || []).map((savedJob) =>
          Number(savedJob.job_id)
        )
      );
    } catch (error) {
      console.error("Error fetching saved jobs:", error);
    }
  };

  fetchSavedJobs();
}, [loggedUser]);

  const professions = [
    "Doctors",
    "Nursing",
    "Pharmacy",
    "Laboratory",
    "Physiotherapy",
    "Radiology",
    "Healthcare Faculty",
    "Hospital Administration",
  ];

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#f8fbfb]">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2.5 sm:py-4">

          <div className="flex w-full min-w-0 items-center justify-between gap-3">

            {/* LOGO */}
           {/* LOGO */}
<div
  className="cursor-pointer flex min-w-0 items-center gap-2 sm:gap-3 flex-shrink-0"
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
>
  {/* HireCura Icon */}
  <img
    src={hireCuraIcon}
    alt="HireCura Icon"
    className="h-8 w-8 sm:h-11 sm:w-11 md:h-12 md:w-12 object-contain"
  />

  {/* Brand Name and Tagline */}
  <div className="flex flex-col">
    <h1 className="text-lg sm:text-2xl md:text-3xl font-bold tracking-tight leading-none">
      <span className="text-slate-900">Hire</span>
      <span className="text-teal-600">Cura</span>
    </h1>

    <p className="text-[7px] sm:text-[10px] md:text-xs text-slate-500 font-medium tracking-wide mt-1">
      Where Careers Meet Care.
    </p>
  </div>
</div>

            {/* NAVIGATION */}
            <nav className="hidden lg:flex items-center gap-8">

              <button
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-teal-600 transition"
              >
                Home
              </button>

              <button
                className="relative text-teal-600 font-semibold"
              >
                Find Jobs
                <span className="absolute -bottom-5 left-0 right-0 h-[3px] bg-teal-600 rounded-full"></span>
              </button>

              {loggedUser?.role !== "candidate" && (
  <button
    onClick={() => navigate("/for-employers")}
    className="text-gray-700 hover:text-teal-600 transition font-medium"
  >
    For Employers
  </button>
)}

              <button
                onClick={() => navigate("/how-it-works")}
                className="text-gray-700 hover:text-teal-600 transition"
              >
                How It Works
              </button>

              <button
                onClick={() => navigate("/about-us")}
                className="text-gray-700 hover:text-teal-600 transition"
              >
                About Us
              </button>

              <button
                onClick={() => navigate("/contact-us")}
                className="text-gray-700 hover:text-teal-600 transition"
              >
                Contact Us
              </button>

            </nav>

            {/* RIGHT */}
            
<div className="hidden md:flex items-center gap-4">
  {loggedUser ? (
    <>
      <FaUser className="text-[#10243e] text-lg" />
      
            <span className="hidden xl:block text-sm font-semibold text-gray-700">
        Welcome, {loggedUser.name || "User"}
      </span>

      <button
        onClick={() =>
          navigate(
            loggedUser.role === "institution"
              ? "/institution"
              : "/candidate-dashboard"
          )
        }
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Dashboard
      </button>

      <button
        onClick={() => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setLoggedUser(null);
          navigate("/");
        }}
        className="border border-red-500 text-red-600 px-5 py-2 rounded-full hover:bg-red-50 transition"
      >
        Logout
      </button>
    </>
  ) : (
    <>
    <FaUser className="text-[#10243e] text-lg" />
      <button
       onClick={() => openLoginModal("candidate")}
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Login
      </button>

      <button
        onClick={() => openLoginModal("institution")}
        className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition"
      >
        Post a Job
      </button>
    </>
  )}
</div>


            <MobileMenu
              onLogin={() => openLoginModal("candidate")}
              loggedUser={loggedUser}
              onLogout={() => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                setLoggedUser(null);
                navigate("/");
              }}
            />
          </div>
        </div>
      </header>


      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#f1fbfa] to-[#e3f7f4]">

        <div className="max-w-7xl mx-auto px-3 sm:px-6 pt-3 sm:pt-8 lg:pt-10">

          <div className="relative min-h-0 sm:min-h-[250px] lg:min-h-[290px] flex items-center">

            {/* TEXT */}
            <div className="relative z-10 w-full py-4 sm:py-8 lg:pb-12">

              <div className="flex items-center gap-2 text-gray-500 text-xs sm:text-sm mb-3">
                <button
                  onClick={() => navigate("/")}
                  className="hover:text-teal-600"
                >
                  Home
                </button>

                <span>›</span>

                <span>Find Jobs</span>
              </div>

              <h1 className="text-2xl leading-tight sm:text-4xl md:text-5xl font-bold text-[#10243e]">
                Find{" "}
                <span className="text-teal-600">
                  Healthcare
                </span>{" "}
                Jobs
              </h1>

              <p className="mt-2 text-sm sm:mt-3 sm:text-lg text-gray-600 leading-relaxed max-w-2xl">
                Explore opportunities from trusted hospitals
                and healthcare employers across India.
              </p>

            </div>

            {/* IMAGE */}
            <div className="absolute right-0 bottom-0 hidden md:block">

              <div className="absolute right-0 bottom-0 w-[470px] h-[250px] bg-teal-100/60 rounded-t-full"></div>

              <img
                src={healthcareHero}
                alt="Healthcare professional"
                className="relative w-[430px] h-[250px] object-cover object-top rounded-t-[180px]"
              />

            </div>

          </div>

        </div>
      </section>


      {/* ================= SEARCH ================= */}
      <section className="relative z-20 -mt-1">

        <div className="max-w-7xl mx-auto px-3 sm:px-6">

          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 p-2.5 sm:p-4">

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_auto] gap-3">

              {/* ROLE */}
              <div className="border border-gray-200 rounded-xl">

                <div className="flex items-center px-3 sm:px-4">

                  <FaBriefcase className="text-[#10243e]" />

                  <input
                    type="text"
                    value={roleSearch}
                    onChange={(e) =>
                      setRoleSearch(e.target.value)
                    }
                    placeholder="Search by role"
                    className="w-full min-w-0 px-2.5 py-2.5 sm:px-3 sm:py-3 text-xs sm:text-base outline-none"
                  />

                </div>

              </div>


              {/* ORGANIZATION */}
              <div className="border border-gray-200 rounded-xl">

                <div className="flex items-center px-3 sm:px-4">

                  <FaBuilding className="text-[#10243e]" />

                  <input
                    type="text"
                    value={organizationSearch}
                    onChange={(e) =>
                      setOrganizationSearch(e.target.value)
                    }
                    placeholder="Search by organization"
                    className="w-full min-w-0 px-2.5 py-2.5 sm:px-3 sm:py-3 text-xs sm:text-base outline-none"
                  />

                </div>

              </div>


              {/* LOCATION */}
              <div className="border border-gray-200 rounded-xl">

                <div className="flex items-center px-3 sm:px-4">

                  <FaMapMarkerAlt className="text-[#10243e]" />

                  <input
                    type="text"
                    value={locationSearch}
                    onChange={(e) =>
                      setLocationSearch(e.target.value)
                    }
                    placeholder="Search by location"
                    className="w-full min-w-0 px-2.5 py-2.5 sm:px-3 sm:py-3 text-xs sm:text-base outline-none"
                  />

                </div>

              </div>


              {/* SEARCH BUTTON */}
              <button
                type="button"
                className="w-full lg:w-auto bg-teal-600 text-white px-4 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg sm:rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-teal-700 transition"
              >
                <FaSearch />
                Search Jobs
              </button>

            </div>

          </div>

        </div>

      </section>


      {/* ================= POPULAR ================= */}
      <section className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-5">

        <div className="flex flex-wrap items-center gap-2 sm:gap-3">

          <span className="text-sm sm:text-base font-semibold text-[#10243e]">
            Popular Searches:
          </span>

          {[
            "Staff Nurse",
            "General Physician",
            "Lab Technician",
            "Pharmacist",
            "Physiotherapist",
            "Radiology Technician",
            "Nursing Tutor",
          ].map((item) => (

            <button
              key={item}
              onClick={() =>
                handlePopularSearch(item)
              }
              className="px-2.5 sm:px-5 py-1.5 sm:py-2 bg-white border border-teal-100 rounded-full text-[11px] sm:text-sm hover:border-teal-400 hover:text-teal-600 transition"
            >
              {item}
            </button>

          ))}

        </div>

      </section>


      {/* ================= JOB CONTENT ================= */}
      <main className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-6 lg:py-4">

        <div className="grid grid-cols-1 lg:grid-cols-[330px_minmax(0,1fr)] gap-5 lg:gap-7">


          {/* ================= SIDEBAR ================= */}
          <aside className="hidden lg:block bg-white rounded-2xl sm:rounded-2xl border border-gray-200 p-3.5 sm:p-5 h-fit lg:sticky lg:top-24 shadow-sm sm:shadow-none">

            <div className="flex items-center justify-between gap-3 mb-0 sm:mb-5">

              <button
                type="button"
                onClick={() => setShowMobileFilters((open) => !open)}
                className="flex flex-1 items-center justify-between text-left sm:cursor-default"
                aria-expanded={showMobileFilters}
              >
                <span className="text-base sm:text-xl font-bold text-[#10243e]">Filters</span>
                <span className="ml-2 text-teal-700 sm:hidden">
                  {showMobileFilters ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </button>

              <button
                onClick={clearAllFilters}
                className="shrink-0 rounded-full border border-teal-100 px-3 py-1.5 text-xs sm:border-0 sm:px-0 sm:py-0 sm:text-sm text-teal-700 font-semibold hover:bg-teal-50 sm:hover:bg-transparent"
              >
                Clear All
              </button>

            </div>

            <div className={`${showMobileFilters ? "block" : "hidden"} sm:block`}></div>
            <div className="mt-4 sm:mt-0">

            {/* PROFESSION */}
            <div className="border-t border-gray-100 pt-4">

              <button
                onClick={() =>
                  setShowMoreProfession(
                    !showMoreProfession
                  )
                }
                className="w-full flex items-center justify-between font-bold text-[#10243e]"
              >

                <span className="flex items-center gap-2">
                  <FaUsers className="text-teal-600" />
                  Profession
                </span>

                {showMoreProfession ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}

              </button>


              <div className="mt-4 space-y-3">

                {professions
                  .slice(
                    0,
                    showMoreProfession ? 8 : 5
                  )
                  .map((profession) => {

                    const value =
                      profession === "Doctors"
                        ? "Doctor"
                        : profession === "Nursing"
                        ? "Nursing"
                        : profession;

                    return (
                      <label
                        key={profession}
                        className="flex items-center gap-2.5 sm:gap-3 cursor-pointer text-sm sm:text-base text-gray-700"
                      >

                        <input
                          type="checkbox"
                          checked={
                            professionFilter === value
                          }
                          onChange={() =>
                            setProfessionFilter(
                              professionFilter === value
                                ? ""
                                : value
                            )
                          }
                          className="w-4 h-4 accent-teal-600"
                        />

                        <span>
                          {profession}
                        </span>

                      </label>
                    );
                  })}

              </div>

              {!showMoreProfession && (
                <button
                  onClick={() =>
                    setShowMoreProfession(true)
                  }
                  className="mt-3 text-teal-600 text-sm font-semibold"
                >
                  Show more ↓
                </button>
              )}

            </div>
            
  
{/* ORGANIZATION */}
<div className="border-t border-gray-100 mt-5 pt-5">
  <div className="flex items-center gap-2 font-bold text-[#10243e] mb-4">
    <FaBuilding className="text-teal-600" />
    Organization
  </div>

  <div className="space-y-3 max-h-52 overflow-y-auto">
    {organizationOptions.length > 0 ? (
      organizationOptions.map((organization) => (
        <label
          key={organization}
          className="flex items-center gap-3 cursor-pointer text-gray-700 text-sm"
        >
          <input
            type="checkbox"
            checked={selectedOrganizations.includes(organization)}
            onChange={(e) => {
              setSelectedOrganizations((previous) =>
                e.target.checked
                  ? [...previous, organization]
                  : previous.filter((item) => item !== organization)
              );
            }}
            className="w-4 h-4 rounded-sm accent-teal-600 shrink-0"
          />
          <span>{organization}</span>
        </label>
      ))
    ) : (
      <p className="text-sm text-gray-500">
        No organizations available
      </p>
    )}
  </div>
</div>




{/* LOCATION */}
<div className="border-t border-gray-100 mt-5 pt-5">
  <div className="flex items-center gap-2 font-bold text-[#10243e] mb-4">
    <FaMapMarkerAlt className="text-teal-600" />
    Location
  </div>

  <div className="space-y-3 max-h-52 overflow-y-auto">
    {locationOptions.length > 0 ? (
      locationOptions.map((jobLocation) => (
        <label
          key={jobLocation}
          className="flex items-center gap-3 cursor-pointer text-gray-700 text-sm"
        >
          <input
            type="checkbox"
            checked={selectedLocations.includes(jobLocation)}
            onChange={(e) => {
              setSelectedLocations((previous) =>
                e.target.checked
                  ? [...previous, jobLocation]
                  : previous.filter((item) => item !== jobLocation)
              );
            }}
            className="w-4 h-4 rounded-sm accent-teal-600 shrink-0"
          />
          <span>{jobLocation}</span>
        </label>
      ))
    ) : (
      <p className="text-sm text-gray-500">
        No locations available
      </p>
    )}
  </div>
</div>


            {/* JOB TYPE */}
            <div className="border-t border-gray-100 mt-5 pt-5">

              <div className="flex items-center gap-2 font-bold text-[#10243e] mb-4">
                <FaBriefcase className="text-teal-600" />
                Job Type
              </div>

              
{[
  "Full Time",
  "Part Time",
  "Contract",
  "Remote",
  "Internship",
].map((type) => (
  <label
    key={type}
    className="flex items-center gap-3 mb-3 cursor-pointer text-gray-700"
  >
    <input
      type="checkbox"
      checked={jobTypeFilter.includes(type)}
      onChange={(e) => {
        setJobTypeFilter((previous) =>
          e.target.checked
            ? [...previous, type]
            : previous.filter((item) => item !== type)
        );
      }}
      className="w-4 h-4 accent-teal-600"
    />

    {type}
  </label>
))}


            </div>
            </div>

          </aside>


          {/* ================= RESULTS ================= */}
          <section className="min-w-0">

            {/* MOBILE FILTER BUTTON */}

{/* MOBILE JOB FILTERS */}
<div className="mb-4 flex items-center justify-between gap-3 lg:hidden">
  <span className="text-sm text-gray-600">
    {filteredJobs.length} jobs found
  </span>

  <button
    type="button"
    onClick={() => {
      setDraftProfessionFilter(professionFilter);
      setDraftJobTypeFilter([...jobTypeFilter]);
      setDraftSelectedOrganizations([...selectedOrganizations]);
      setDraftSelectedLocations([...selectedLocations]);
      setShowMobileFilters(true);
    }}
    className="inline-flex items-center gap-2 rounded-xl border border-teal-200 bg-white px-4 py-2.5 text-sm font-semibold text-teal-700 shadow-sm active:bg-teal-50"
    aria-label="Open job filters"
  >
    <FaFilter className="text-teal-600" />
    Filters

    {(professionFilter ||
      jobTypeFilter.length > 0 ||
      selectedOrganizations.length > 0 ||
      selectedLocations.length > 0) && (
      <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-teal-600 px-1 text-xs text-white">
        {(professionFilter ? 1 : 0) +
          jobTypeFilter.length +
          selectedOrganizations.length +
          selectedLocations.length}
      </span>
    )}
  </button>
</div>

{/* MOBILE FILTER DRAWER */}
{showMobileFilters && (
  <div className="fixed inset-0 z-[120] lg:hidden">

    {/* BACKDROP */}
    <button
      type="button"
      aria-label="Close filters"
      onClick={() => setShowMobileFilters(false)}
      className="absolute inset-0 bg-slate-950/50"
    />

    {/* FILTER PANEL */}
    <div className="absolute inset-x-0 bottom-0 flex max-h-[88dvh] flex-col rounded-t-3xl bg-white shadow-2xl">

      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
        <div>
          <h3 className="text-lg font-bold text-[#10243e]">
            Filter Jobs
          </h3>
          <p className="mt-0.5 text-xs text-gray-500">
            Choose filters, then apply
          </p>
        </div>

        <button
          type="button"
          onClick={() => setShowMobileFilters(false)}
          className="rounded-full bg-gray-100 p-2.5 text-gray-700"
          aria-label="Close filters"
        >
          <FaTimes />
        </button>
      </div>

      {/* FILTER CONTENT */}
      <div className="min-h-0 flex-1 space-y-5 overflow-y-auto px-5 py-4">

        {/* PROFESSION */}
        <div>
          <h4 className="mb-3 flex items-center gap-2 font-semibold text-[#10243e]">
            <FaUsers className="text-teal-600" />
            Profession
          </h4>

          <div className="flex flex-wrap gap-2">
            {professions.map((profession) => {
              const value =
                profession === "Doctors"
                  ? "Doctor"
                  : profession === "Nursing"
                  ? "Nursing"
                  : profession;

              const active = draftProfessionFilter === value;

              return (
                <button
                  key={profession}
                  type="button"
                  onClick={() =>
                    setDraftProfessionFilter(active ? "" : value)
                  }
                  className={`rounded-full border px-3.5 py-2 text-sm transition ${
                    active
                      ? "border-teal-600 bg-teal-600 text-white"
                      : "border-gray-200 bg-white text-gray-700"
                  }`}
                >
                  {profession}
                </button>
              );
            })}
          </div>
        </div>

       
        {/* ORGANIZATION */}
        <div className="border-t border-gray-100 pt-4">

          <h4 className="mb-3 flex items-center gap-2 font-semibold text-[#10243e]">
            <FaBuilding className="text-teal-600" />
            Organization
          </h4>

          {organizationOptions.length ? (
            <div className="max-h-40 space-y-3 overflow-y-auto">

              {organizationOptions.map((organization) => (
                <label
                  key={organization}
                  className="flex items-center gap-3 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={draftSelectedOrganizations.includes(organization)}
                    onChange={(e) =>
                      setDraftSelectedOrganizations((prev) =>
                        e.target.checked
                          ? [...prev, organization]
                          : prev.filter((item) => item !== organization)
                      )
                    }
                    className="h-4 w-4 shrink-0 accent-teal-600"
                  />

                  <span>{organization}</span>
                </label>
              ))}

            </div>
          ) : (
            <p className="text-sm text-gray-500">
              No organizations available
            </p>
          )}
        </div>

        {/* LOCATION */}
        <div className="border-t border-gray-100 pt-4">

          <h4 className="mb-3 flex items-center gap-2 font-semibold text-[#10243e]">
            <FaMapMarkerAlt className="text-teal-600" />
            Location
          </h4>

          {locationOptions.length ? (
            <div className="max-h-40 space-y-3 overflow-y-auto">

              {locationOptions.map((jobLocation) => (
                <label
                  key={jobLocation}
                  className="flex items-center gap-3 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={draftSelectedLocations.includes(jobLocation)}
                    onChange={(e) =>
                      setDraftSelectedLocations((prev) =>
                        e.target.checked
                          ? [...prev, jobLocation]
                          : prev.filter((item) => item !== jobLocation)
                      )
                    }
                    className="h-4 w-4 shrink-0 accent-teal-600"
                  />

                  <span>{jobLocation}</span>
                </label>
              ))}

            </div>
          ) : (
            <p className="text-sm text-gray-500">
              No locations available
            </p>
          )}
        </div>
           {/* JOB TYPE */}
        <div className="border-t border-gray-100 pt-4">

          <h4 className="mb-3 flex items-center gap-2 font-semibold text-[#10243e]">
            <FaBriefcase className="text-teal-600" />
            Job Type
          </h4>

          <div className="grid grid-cols-2 gap-x-4 gap-y-3">
            {[
              "Full Time",
              "Part Time",
              "Contract",
              "Remote",
              "Internship",
            ].map((type) => (
              <label
                key={type}
                className="flex items-center gap-3 text-sm text-gray-700"
              >
                <input
                  type="checkbox"
                  checked={draftJobTypeFilter.includes(type)}
                  onChange={(e) => {
                    setDraftJobTypeFilter((previous) =>
                      e.target.checked
                        ? [...previous, type]
                        : previous.filter((item) => item !== type)
                    );
                  }}
                  className="h-4 w-4 shrink-0 accent-teal-600"
                />

                <span>{type}</span>
              </label>
            ))}
          </div>
        </div>

      </div>

      {/* FOOTER BUTTONS */}
      <div className="flex gap-3 border-t border-gray-100 bg-white px-5 py-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">

        {/* RESET */}
        <button
          type="button"
          onClick={() => {
            setDraftProfessionFilter("");
            setDraftJobTypeFilter([]);
            setDraftSelectedOrganizations([]);
            setDraftSelectedLocations([]);
          }}
          className="flex-1 rounded-xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
        >
          Reset
        </button>

        {/* APPLY FILTERS */}
        <button
          type="button"
          onClick={() => {
            setProfessionFilter(draftProfessionFilter);
            setJobTypeFilter(draftJobTypeFilter);
            setSelectedOrganizations(draftSelectedOrganizations);
            setSelectedLocations(draftSelectedLocations);
            setCurrentPage(1);
            setShowMobileFilters(false);
          }}
          className="flex-1 rounded-xl bg-teal-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700"
        >
          Apply Filters
        </button>

      </div>

    </div>
  </div>
)}

{/* RESULTS HEADER */}
<div className="mb-4 flex flex-col gap-3 sm:mb-5 sm:flex-row sm:items-center sm:justify-between sm:gap-4">

  <h2 className="text-xl font-bold text-[#10243e] sm:text-2xl md:text-3xl">
    {filteredJobs.length} Healthcare Jobs
  </h2>

  <div className="flex items-center gap-2">

    <span className="text-sm text-gray-500">
      Sort by
    </span>

    <select
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
      className="rounded-xl border border-gray-200 bg-white px-3 py-2 outline-none sm:px-4"
    >
      <option>Latest</option>
      <option>Oldest</option>
    </select>

  </div>
</div>


            {/* JOB CARDS */}
            {sortedJobs.length === 0 ? (

              <div className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 p-6 sm:p-12 text-center">

                <h3 className="text-lg sm:text-xl font-bold text-gray-700">
                  No Healthcare Jobs Found
                </h3>

                <p className="text-gray-500 mt-2">
                  Try changing your search or filters.
                </p>

              </div>

            ) : (

              <div className="space-y-3">

               {paginatedJobs.map((job) => {

                  const organization =
                    job.organization_name ||
                    job.company_name ||
                    job.institution_name ||
                    "Healthcare Organization";

                  const logo = job.company_logo
                    ? `${API_URL.replace('/api', '')}/${job.company_logo}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        organization
                      )}&background=e6f7f4&color=008f83&bold=true`;

                  return (

                    <div
                      key={job.id}
                      className="relative bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-3.5 sm:p-5 hover:border-teal-200 hover:shadow-md transition"
                    >

                      {/* Mobile-only save icon in the top-right corner */}
                      <button
                        type="button"
                        aria-label="Save job"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleBookmark(job.id);
                        }}
                        className={`sm:hidden absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white border border-gray-100 shadow-sm ${
                          bookmarkedJobs.includes(job.id) ? "text-teal-600" : "text-[#10243e]"
                        }`}
                      >
                        <FaBookmark className="text-base" />
                      </button>

                      <div className="flex flex-row items-start gap-3 sm:gap-5">

                        {/* LOGO */}
                        <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-xl border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">

                          <img
                            src={logo}
                            alt={organization}
                            className="w-full h-full object-contain"
                          />

                        </div>


                        {/* DETAILS */}
                        <div className="flex-1 min-w-0">

                          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2 sm:gap-3 min-w-0">

                            <div>

                              <div className="flex items-center gap-2">

                                <h3 className="text-base sm:text-xl font-bold text-[#10243e] break-words max-sm:pr-8">
                                  {job.role}
                                </h3>

                              </div>

                              <p className="text-sm sm:text-base text-gray-600 mt-1 break-words">
                                {organization}
                              </p>

                            </div>


                            {/* TYPE / TIME */}
                            <div className="flex flex-wrap items-center gap-2 sm:gap-4">

                              <span className="bg-[#e1f8f2] text-[#008f83] px-2.5 sm:px-4 py-1 sm:py-2 rounded-md sm:rounded-lg text-[11px] sm:text-sm font-semibold">
                                {job.job_type ||
                                  job.employment_type ||
                                  "Healthcare"}
                              </span>

                              <span className="hidden sm:inline text-xs sm:text-sm text-gray-500 whitespace-nowrap">
                                {getTimeAgo(
                                  job.created_at
                                )}
                              </span>

                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleBookmark(job.id);
                                }}
                                className={`hidden sm:inline-flex text-base sm:text-lg ${
                                  bookmarkedJobs.includes(
                                    job.id
                                  )
                                    ? "text-teal-600"
                                    : "text-[#10243e]"
                                }`}
                              >
                                <FaBookmark />
                              </button>

                            </div>

                          </div>


                          {/* META */}
                          <div className="flex flex-col sm:flex-row sm:flex-wrap items-start gap-x-7 gap-y-2 sm:gap-y-3 mt-3 sm:mt-5 text-xs sm:text-sm text-gray-600">

                            <span className="flex items-center gap-2">
                              <FaMapMarkerAlt className="text-[#10243e]" />
                              {job.location ||
                                "Location not specified"}
                            </span>

                            <span className="flex items-center gap-2">
                              <FaBriefcase className="text-[#10243e]" />
                              {job.experience_required
                                ? `${job.experience_required} years`
                                : "Experience not specified"}
                            </span>

                            <span className="flex items-center gap-2">
                              <FaGraduationCap className="text-[#10243e]" />
                              {job.qualification ||
                                job.profession ||
                                "Healthcare"}
                            </span>

                          </div>


                          {/* Mobile-only timestamp below the job information */}
                          <div className="sm:hidden mt-3 flex items-center gap-1.5 text-[11px] text-gray-500">
                            <FaClock className="text-[11px]" />
                            <span>Posted {getTimeAgo(job.created_at)}</span>
                          </div>

                          {/* BOTTOM */}
                          <div className="flex justify-stretch sm:justify-end mt-4">

                            <button
                              onClick={() =>
                                navigate(
                                  `/job/${job.id}`
                                )
                              }
                              className="w-full sm:w-auto bg-teal-600 text-white px-4 sm:px-6 py-2 sm:py-2.5 text-sm sm:text-base rounded-xl sm:rounded-xl font-semibold hover:bg-teal-700 transition"
                            >
                              View Details →
                            </button>

                          </div>

                        </div>

                      </div>

                    </div>

                  );
                })}


              </div>

            )}

              {/* ================= PAGINATION ================= */}
              {totalPages > 1 && (
                <div className="mt-8 flex flex-col items-center gap-4">

                  {/* Results range */}
                  <p className="text-sm text-gray-500">
                    Showing {startIndex + 1}–
                    {Math.min(
                      startIndex + JOBS_PER_PAGE,
                      sortedJobs.length
                    )} of {sortedJobs.length} jobs
                  </p>

                  {/* Pagination controls */}
                  <div className="flex flex-wrap items-center justify-center gap-2">

                    {/* Previous */}
                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((page) =>
                          Math.max(1, page - 1)
                        )
                      }
                      disabled={currentPage === 1}
                      className="flex items-center gap-1 rounded-lg border border-gray-200 px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-gray-700 transition hover:border-teal-500 hover:text-teal-600 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      <span aria-hidden="true">←</span>
                      Previous
                    </button>

                    {/* Page numbers */}
                    {Array.from(
                      { length: totalPages },
                      (_, index) => index + 1
                    ).map((page) => (
                      <button
                        key={page}
                        type="button"
                        onClick={() => setCurrentPage(page)}
                        aria-label={`Go to page ${page}`}
                        aria-current={
                          currentPage === page ? "page" : undefined
                        }
                        className={`min-w-8 sm:min-w-10 rounded-lg border px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold transition ${
                          currentPage === page
                            ? "border-teal-600 bg-teal-600 text-white"
                            : "border-gray-200 bg-white text-gray-700 hover:border-teal-500 hover:text-teal-600"
                        }`}
                      >
                        {page}
                      </button>
                    ))}

                    {/* Next */}
                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((page) =>
                          Math.min(totalPages, page + 1)
                        )
                      }
                      disabled={currentPage === totalPages}
                      className="flex items-center gap-1 rounded-lg border border-gray-200 px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-gray-700 transition hover:border-teal-500 hover:text-teal-600 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      Next
                      <span aria-hidden="true">→</span>
                    </button>
                      
                  </div>
                </div>
              )}
          </section>
          

        </div>

      </main>
      <LoginModal
  isOpen={showLoginModal}
  initialRole={loginRole}
  onClose={() => setShowLoginModal(false)}
/>

    </div>
  );
}

export default FindJobs;
